<template>
  <div id="app">
    <router-view :key="$route.path"/>
    <Footer/>
  </div>
</template>

<script>
import Footer from '@/components/Footer.vue'

export default {
  name: "App",
  methods: {
    updatePageTitleForRoute(route) {
      var title = "boosh"
      if (route.name === "User") {
        title = route.params?.username + " | boosh"
      }
      if (route.name === "Subreddit") {
        title = route.params?.subreddit + " | boosh"
      }
      else if (route.name === "Acknowledgements") {
        title = "Acknowledgements | boosh"
      }
      document.title = title
    }
  },
  watch: {
    $route: {
      immediate: true,
      // eslint-disable-next-line
      handler(to, from) {
        this.updatePageTitleForRoute(to)
      }
    }
  },
  components: {
    Footer
  }
}
</script>

<style>
/* Global CSS variables */
:root {
  --active-element-highlight: #00B4CC;
  --lighter-main-color: #7C8E90;
  --link-color: var(--active-element-highlight);
  --main-color: #2C3E50;
  --max-content-width: 1600px;
  --search-bar-fade-duration: .3s;
  --site-background-color: white;
}

html, body {
  overflow-x: hidden;
  /* potential dark mode background color: background-color: #2e2f32;*/
}

body {
  position: relative
}

a {
  color: var(--link-color);
}

#app {
  font-family: Verdana, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: var(--main-color);
  padding: 0 1em;
}

#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: var(--main-color);
}

#nav a.router-link-exact-active {
  color: #42b983;
}
</style>
